enum EventType {
  PURCHASE = 0,
  START_TRIAL = 1,
  CUSTOM_EVENT= 2,
}

type EventTypesStrings = keyof typeof EventType;

export { EventTypesStrings, EventType }
